import { Page } from '@/core/architecture'

import { ArtistMembershipCompletionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistMembershipCompletion Page
 * Implemented as a practical sample.
 */
export const ArtistMembershipCompletion: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistMembershipCompletionTemplate state={state} {...actions} />
}
